import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowRight } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useCallback } from "react";
import { useDiscussionPanelContext } from "~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext";
import { ANNOTATION_REPLY_BUTTON } from "~/constants/testIDs";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
export const AnnotationReplyButton = /*#__PURE__*/ memo((param)=>{
    let { discussion } = param;
    const { setReplyingDiscussionId } = useDiscussionPanelContext();
    const { showPanel } = useAssetModalPanelContext();
    const onReplyClick = useCallback((event)=>{
        event.stopPropagation();
        showPanel(AssetModalPanel.COMMENTS);
        setReplyingDiscussionId(discussion.id);
    }, [
        discussion.id,
        setReplyingDiscussionId,
        showPanel
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "ghost",
        color: "grey",
        className: "-ml-2",
        "data-testid": ANNOTATION_REPLY_BUTTON,
        onClick: onReplyClick,
        suffix: /*#__PURE__*/ _jsx(ArrowRight, {
            className: "size-4"
        }),
        size: "small",
        children: "Reply"
    });
});
AnnotationReplyButton.displayName = "AnnotationReplyButton";
